import {
  IFieldSubmissionMap,
  IFormFieldSubmission,
} from "@common/redux/formSubmission/interface";
import { FieldProps } from "../FormFieldSelector/interfaces";
import {
  IPincodeFieldConfigurationServer,
  IPincodeFieldConfigurationClient,
} from "./interface";
import { validateRule } from "../FormTextInputField/rules/utils";
import { IOption } from "@erelego/design-system/components/atoms/DropdownSelect/component/OptionItem";
import { IFieldsMap } from "@erelego/design-system/interface/Forms/formBuilderInterface";
import { formFieldInitialSubmissionValues } from "@presentation/FormBuilder/utils";
import { transformFieldSubmissionValueFromServerToClient } from "@common/redux/formSubmission/utils";
import { IPincodeData } from "./components/ViewPincodeComponent";

export const transformPincodeFieldConfigClientToServer = (
  fieldConfigClient: IPincodeFieldConfigurationClient
): IPincodeFieldConfigurationServer => {
  const { taluk, placename, state, district, isAutoFetch, country } =
    fieldConfigClient;
  const fieldConfigServer = {
    taluk,
    placename,
    state,
    district,
    country,
    isAutoFetch,
  };
  return fieldConfigServer;
};

export const transformPincodeConfigServerToClient = (
  fieldConfigServer: IPincodeFieldConfigurationServer
): IPincodeFieldConfigurationClient => {
  const { taluk, placename, state, district, isAutoFetch, country } =
    fieldConfigServer;

  const fieldConfigClient = {
    taluk,
    placename,
    state,
    district,
    country,
    isAutoFetch,
  };
  return fieldConfigClient;
};

export const validatePincodeFieldSubmissionData = (
  fieldEditConfig: FieldProps,
  fieldSubmissionData: IFormFieldSubmission,
  fieldSubmissionMap: IFieldSubmissionMap
): [boolean, string] => {
  const { isRequired, rules: fieldRules } = fieldEditConfig;
  const fieldSubmissionValue = fieldSubmissionData?.fieldSubmissionValue;

  const submissionValue =
    (fieldSubmissionValue && fieldSubmissionValue?.value) || "";

  if (fieldRules && submissionValue) {
    for (let i = 0; i < fieldRules?.length; i++) {
      const [isValidated, validatationErrorMessage] = validateRule(
        fieldRules[i],
        submissionValue,
        fieldSubmissionMap
      );
      if (!isValidated && validatationErrorMessage != "") {
        return [isValidated, validatationErrorMessage];
      }
    }
  }

  if (isRequired) {
    if (!submissionValue) {
      return [false, "Value is required"];
    }
  }
  return [true, ""];
};

export const getSelectedOptionByField = (
  fieldsMap: any,
  fieldId: string
): IOption => {
  let options: IOption = {
    value: "",
    content: "",
  };

  Object.keys(fieldsMap ?? {}).map((key: string) => {
    if (fieldsMap[key]?.localId == fieldId) {
      options = {
        value: fieldId,
        content: fieldsMap[key].title,
      };
    }
  });
  return options;
};
export interface IPinCodeFieldMap {
  fieldType?: string;
  fieldId?: string;
}
export const getSubmissionValue = (
  pinCodeData: IPincodeData,
  countryName: string
) => {
  const data = {
    statename: pinCodeData?.statename ?? "",
    taluk: pinCodeData?.taluk ?? "",
    placename: pinCodeData?.placename ?? "",
    districtname: pinCodeData?.districtname ?? "",
    country: countryName ?? "",
  };

  return data;
};
export const getFieldsMap = (
  fieldConfig: IPincodeFieldConfigurationClient
): IPinCodeFieldMap[] => {
  const data: IPinCodeFieldMap[] = [
    {
      fieldType: "statename",
      fieldId: fieldConfig.state ?? "",
    },
    {
      fieldType: "taluk",
      fieldId: fieldConfig.taluk ?? "",
    },
    {
      fieldType: "placename",
      fieldId: fieldConfig.placename ?? "",
    },
    {
      fieldType: "districtname",
      fieldId: fieldConfig.district ?? "",
    },
    {
      fieldType: "country",
      fieldId: fieldConfig.country ?? "",
    },
  ];
  return data;
};
export const updateBulkSubmissionValueForPincode = (
  fieldSubmissionMap: IFieldSubmissionMap,
  mapFieldsValue: IPinCodeFieldMap[],
  submissionValues: any,
  fieldsMap: IFieldsMap,
  countryName: string,
  formId: string,
): IFormFieldSubmission[] => {
  const fieldSubmissionData: IFormFieldSubmission[] = [];
  mapFieldsValue?.forEach((mapValue: IPinCodeFieldMap) => {
    const fromFieldType = mapValue?.fieldType;
    const toFieldId = mapValue?.fieldId;
    const fromFieldSubmissionValue = submissionValues[fromFieldType];

    let toFieldSubmissionData: IFormFieldSubmission =
      fieldSubmissionMap[toFieldId];
    const toFieldData: any = fieldsMap[toFieldId];
    if (!toFieldSubmissionData) {
      toFieldSubmissionData = formFieldInitialSubmissionValues(
        toFieldId,
        toFieldData
      );
    }
    if (fromFieldSubmissionValue) {
      const updatedSubmissionValue =
        transformFieldSubmissionValueFromServerToClient(
          toFieldSubmissionData?.fieldType,
          fromFieldSubmissionValue,
          formId,
          [],
          [],
          fieldsMap
        );
      const updatedToFieldSubmissionData: IFormFieldSubmission = {
        ...toFieldSubmissionData,
        fieldSubmissionValue: updatedSubmissionValue,
      };
      fieldSubmissionData.push(updatedToFieldSubmissionData);
    }
  });
  return fieldSubmissionData;
};
